"use strict";
/*!
 *
 * Copyright 2017 - acrazing
 *
 * @author acrazing joking.young@gmail.com
 * @since 2017-12-15 12:29:38
 * @version 1.0.0
 * @desc consts.ts
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANY = void 0;
exports.NULL = null;
exports.T_SECOND = 1000;
exports.T_MINUTE = 60000;
exports.T_HOUR = 3600000;
exports.T_DAY = 86400000;
exports.S_SECOND = 1;
exports.S_MINUTE = 60;
exports.S_HOUR = 3600;
exports.S_DAY = 86400;
exports.noop = () => void 0;
exports.UINT32_MAX = 0xffffffff;
exports.INT32_MIN = -0x80000000;
exports.INT32_MAX = +0x7fffffff;
//# sourceMappingURL=consts.js.map